import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
const FormGroupControl = ({ className, children })=>/*#__PURE__*/ React.createElement("div", {
        className: cx('FormGroup-control', className)
    }, children);
FormGroupControl.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};
export default FormGroupControl;
